import syled from 'styled-components';

export const Wrapper = syled.div``;
